import { RouterState }      from 'connected-react-router';
import React                from 'react';
import {
  useDispatch,
  useSelector
}                           from "react-redux";
import service              from '../../../services';
import { ApplicationState } from "../../../store";
import { APIState }         from "../../../store/API/types";
import { BookmarkState }    from '../../../store/bookmarks/types';
import { BrowseState }      from "../../../store/browse/types";
import { LayoutState }      from "../../../store/layouts/types";
import {
  resetTimestrips,
  setPlaybackmode,
  setTimelineDate
}                           from "../../../store/timeline/actions";
import { TimelineState }    from "../../../store/timeline/types";
import { Routes }           from '../../../types';
import {
  chooseService,
  doCayugaBrowseGoTo,
  getStripHighTime,
  playBackUpdateTimeCb,
  skipGapsStipTime,
  StripType
}                           from '../../../utils';

import { IconComponent } from "../../reusable/simpleComponents";

// TODO
// Change update time dispatches to one global function with dispatch injectiction

const SequenceBackUIComponent = () => {
  const {time, playbackMode} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const {browsePanes} = useSelector<ApplicationState, BrowseState>(state => state.browse);
  const {bookmarks} = useSelector<ApplicationState, BookmarkState>(state => state.bookmarks);
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const {checkedPane} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);
  const dispatch = useDispatch();
  const panes = location.pathname === Routes.bookmarks ? bookmarks : browsePanes;

  const updateTime = playBackUpdateTimeCb(time, dispatch);

  const handler = () => {
    if (playbackMode !== 'pause') dispatch(setPlaybackmode('pause'));

    Object.keys(panes).forEach(pane => {
      const el = document.getElementById(`thumbnail-${pane}`);
      if (el) {
        //@ts-ignore
        const prevTime = el.browseFrame ? +el.browseFrame.startTime : time;
        const updateTimeCb = parseInt(pane) === checkedPane ? updateTime : () => {};
        chooseService(
          () => {
            prevTime && service.browsePrevSequence({
              time: prevTime,
              pane: parseInt(pane),
              token,
              id: `thumbnail-${pane}`,
              cb: updateTimeCb
            });
          },
          () => {
            const {timestrips} = panes[pane];
            if (!timestrips) return;
            const activeTimeStrips = timestrips.filter((strip: any) => strip.type !== 5 && strip.type !== 0);
            const bkmksTimeStips = timestrips.filter((strip: any) => strip.type === 0 && strip.high < time);

            const closest = activeTimeStrips.filter((s: any) => time >= s.low && time <= s.high)[0];
            const closestBkm = bkmksTimeStips.length > 0 ? bkmksTimeStips.reduce((prev: any, curr: any) =>
              Math.abs(time - curr.high) < Math.abs(time - prev.high)
                ? curr
                : prev
            ) : null;
            if (closestBkm) {
              if (closest) {
                if (closest.low <= closestBkm.high && closest.high >= closestBkm.high) {
                  dispatch(setTimelineDate(closestBkm.high));
                  dispatch(resetTimestrips(closestBkm.high));

                  doCayugaBrowseGoTo(token, closestBkm.high, parseInt(pane), -1, panes[pane].id, service);
                  return;
                }
              }
            }
            if (closest == null) {
              const skipTime = skipGapsStipTime(timestrips, time, -1, parseInt(pane));

              if (skipTime == null) return null;
              dispatch(setTimelineDate(skipTime));
              dispatch(resetTimestrips(skipTime));

              return doCayugaBrowseGoTo(token, skipTime, parseInt(pane), -1, panes[pane].id, service);
            }

            const stripIndex = activeTimeStrips.findIndex(({high, low}: StripType) => {
              return closest.high === high && closest.low === low
            });


            if (stripIndex === -1) return null;
            const gotoTime = getStripHighTime(time, closest, activeTimeStrips, stripIndex);

            if (gotoTime == null) return null;

            dispatch(setTimelineDate(gotoTime));
            dispatch(resetTimestrips(gotoTime));

            doCayugaBrowseGoTo(token, gotoTime, parseInt(pane), -1, panes[pane].id, service);
          }
        )
      }
    })
  };

  return (
    <IconComponent classValue={'player move-back icon playback-icon'}
                   handler={handler}
                   title="Step Back to Previous Sequence"
    />
  )
};

export default SequenceBackUIComponent